import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/icons/openlistdetails.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"25px"},
  alt: "listdetailsimg",
  title: "listdetailsimg"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createBlock(_component_el_table, {
    id: "productslisttable",
    data: _ctx.productsList,
    style: {"width":"100%"},
    "header-cell-style": _ctx.headerstyle,
    "row-style": _ctx.rowdatastyle,
    "empty-text": "No products data available"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_table_column, {
        label: "Product Name",
        prop: "productName"
      }),
      _createVNode(_component_el_table_column, { label: "Version" }, {
        default: _withCtx((props) => [
          _createTextVNode(_toDisplayString(props.row.majorVersionNumber) + "." + _toDisplayString(props.row.minorVersionNumber), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        label: "License Type",
        prop: "licenseType"
      }),
      _createVNode(_component_el_table_column, { label: "License Used" }, {
        default: _withCtx((props) => [
          _createTextVNode(_toDisplayString(props.row.seatsUsed) + "/ " + _toDisplayString(props.row.seats), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        fixed: "right",
        label: "",
        width: "120"
      }, {
        default: _withCtx((product) => [
          _createVNode(_component_el_button, {
            onClick: ($event: any) => (_ctx.viewDetails(product)),
            size: "small",
            id: "viewdetails",
            link: ""
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["data", "header-cell-style", "row-style"]))
}